import React, { Component } from 'react';
import WorkOrders from './WorkOrders';
import NewBuilding from './creation/NewBuilding';
import WorkOrderCreated from './creation/WorkOrderCreated';
import Tasks from './creation/Tasks';
import WorkingHours from './creation/WorkingHours';
import WorkOrderSummary from './creation/WorkOrderSummary';
import { Redirect, Route, Switch } from 'react-router-dom';
import BuildingSelection from './creation/BuildingSelection';
import SubContractorsUnionTrades from './creation/SubContractorsUnionTrades';
import WorkOrderDetails from './details/WorkOrderDetails';
import NewWorkOrderRouteGuard from './NewWorkOrderRouteGuard';
import { connect } from 'react-redux';
import { getCurrentUser } from '../../../selectors/authentication';
import { ROLES, TYPES, usersUtil } from '../../../services/utils/users-util';
import ClientSelection from './creation/ClientSelection';
import { getCurrentWorkOrder } from '../../../selectors/admin/work-orders/work-orders';
import { showErrorMessage } from '../../../actions/messages';

/**
 * Parent container for all work orders components/routes. Also catch render errors and redirects to /
 */
class WorkOrdersContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    this.props.dispatch(
      showErrorMessage(
        'Something went wrong with the request, please try again later.'
      )
    );
  }

  render() {
    if (this.state.hasError) {
      return <Redirect to="/" />;
    } else {
      return (
        <div>
          <Switch>
            <Route
              exact
              path={`${this.props.match.url}/`}
              component={WorkOrders}
            />
            <Route
              exact
              path={`${this.props.match.url}/new-work-order`}
              render={() =>
                // Only show client selection if user is admin and no WO is created yet
                (usersUtil.hasRole(
                  this.props.currentUser,
                  ROLES.SPACKLE_ADMIN
                ) ||
                  usersUtil.hasType(
                    this.props.currentUser,
                    TYPES.GENERAL_CONTRACTOR
                  )) &&
                this.props.currentWorkOrder === null ? (
                  <Redirect to={`${this.props.match.url}/client-selection`} />
                ) : (
                  <Redirect to={`${this.props.match.url}/building-selection`} />
                )
              }
            />
            <Route
              exact
              path={`${this.props.match.url}/client-selection`}
              component={ClientSelection}
            />
            <Route
              exact
              path={`${this.props.match.url}/building-selection`}
              component={BuildingSelection}
            />
            <Route
              exact
              path={`${this.props.match.url}/new-building`}
              component={NewBuilding}
            />
            <NewWorkOrderRouteGuard
              exact
              path={`${this.props.match.url}/work-order-created`}
              component={WorkOrderCreated}
            />
            <NewWorkOrderRouteGuard
              exact
              path={`${this.props.match.url}/tasks`}
              component={Tasks}
            />
            <NewWorkOrderRouteGuard
              exact
              path={`${this.props.match.url}/sub-contractors-union-trades`}
              component={SubContractorsUnionTrades}
            />
            <NewWorkOrderRouteGuard
              exact
              path={`${this.props.match.url}/working-hours`}
              component={WorkingHours}
            />
            <NewWorkOrderRouteGuard
              exact
              path={`${this.props.match.url}/work-order-summary`}
              component={WorkOrderSummary}
            />

            <Route
              exact
              path={`${this.props.match.url}/:woId`}
              component={WorkOrderDetails}
            />
            <Route
              exact
              path={`${this.props.match.url}/:woId/task/:taskId`}
              component={WorkOrderDetails}
            />
          </Switch>
        </div>
      );
    }
  }
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
    currentWorkOrder: getCurrentWorkOrder(state),
  };
})(WorkOrdersContainer);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/WorkOrdersContainer.js